import api from '@/lib/axios';
import {
  PartnerPageDataResponse,
  SubmitPartnerInquiryRequest,
  InquirySubmittedResponse,
  PublicPartnerCategoryResponse
} from '../types/partners.types';

export const partnersApi = {
  /**
   * Get all partner page data (content, categories, featured partners)
   */
  getPageData: async (): Promise<PartnerPageDataResponse> => {
    const response = await api.get<PartnerPageDataResponse>('/public/partners');
    return response.data;
  },

  /**
   * Get categories with their partners
   */
  getCategories: async (): Promise<PublicPartnerCategoryResponse[]> => {
    const response = await api.get<PublicPartnerCategoryResponse[]>('/public/partners/categories');
    return response.data;
  },

  /**
   * Submit a partner inquiry
   */
  submitInquiry: async (data: SubmitPartnerInquiryRequest): Promise<InquirySubmittedResponse> => {
    const response = await api.post<InquirySubmittedResponse>('/public/partners/inquiries', data);
    return response.data;
  },
};
